// Module
var code = "<div id=\"V-F470BF47-B480-4AE3-8632-7330F6A903AA\"> <div data-b-component=\"button\" data-b-attr-class=\"{Binding Class}\" data-b-attr-style=\"{Binding Style}\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding Content}\" class=\"stretch-content\"> </div> </div> </div> ";
// Exports
export default code;